(() => {
  /*
   * Prevent duplicate initialization if Shopify or another section
   * accidentally loads this asset more than once.
   */
  if (window.XwallxSamplePopupInitialized) return;
  window.XwallxSamplePopupInitialized = true;

  function initializeSamplePopup() {
    const popup = document.querySelector('[data-sample-popup]');
    const form = popup?.querySelector('[data-sample-form]');

    if (!popup || !form) return;

    const closeButton = popup.querySelector(
      '[data-close-sample-popup]'
    );
    const statusElement = popup.querySelector(
      '[data-sample-status]'
    );

    let openingButton = null;
    let isSubmitting = false;

    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    function updateStatus(message = '', isError = false) {
      if (!statusElement) return;

      statusElement.textContent = message;
      statusElement.classList.toggle('is-error', isError);
    }

    function getFocusableElements() {
      return Array.from(
        popup.querySelectorAll(focusableSelector)
      ).filter((element) => {
        return (
          element.offsetParent !== null &&
          element.getAttribute('aria-hidden') !== 'true'
        );
      });
    }

    function populateProductData(button) {
      const productId = button.dataset.productId || '';
      const productTitle = button.dataset.productTitle || '';
      const productHandle = button.dataset.productHandle || '';
      const productImage = button.dataset.productImage || '';

      const productIdInput = form.querySelector(
        'input[name="properties[Main Product Id]"]'
      );
      const productTitleInput = form.querySelector(
        'input[name="properties[Main Product]"]'
      );
      const productHandleInput = form.querySelector(
        'input[name="properties[Main Product Handle]"]'
      );

      if (productIdInput) productIdInput.value = productId;
      if (productTitleInput) productTitleInput.value = productTitle;
      if (productHandleInput) productHandleInput.value = productHandle;

      form.dataset.productId = productId;
      form.dataset.productTitle = productTitle;
      form.dataset.productHandle = productHandle;
      form.dataset.productImage = productImage;

      popup.dataset.productId = productId;

      return Boolean(productId && productTitle && productHandle);
    }

    function openPopup(button) {
      if (!populateProductData(button)) {
        return;
      }

      openingButton = button;
      updateStatus('');

      popup.classList.remove('hide');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sample-popup-open');

      window.requestAnimationFrame(() => {
        const firstFocusable =
          closeButton || getFocusableElements()[0];

        if (firstFocusable) {
          firstFocusable.focus();
        } else {
          popup.focus();
        }
      });
    }

    function closePopup() {
      if (isSubmitting) return;

      popup.classList.add('hide');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sample-popup-open');
      updateStatus('');

      if (
        openingButton &&
        document.documentElement.contains(openingButton)
      ) {
        openingButton.focus();
      }

      openingButton = null;
    }

    function handleFocusTrap(event) {
      if (event.key !== 'Tab') return;

      const focusableElements = getFocusableElements();

      if (!focusableElements.length) {
        event.preventDefault();
        popup.focus();
        return;
      }

      const firstElement = focusableElements[0];
      const lastElement =
        focusableElements[focusableElements.length - 1];

      if (
        event.shiftKey &&
        document.activeElement === firstElement
      ) {
        event.preventDefault();
        lastElement.focus();
        return;
      }

      if (
        !event.shiftKey &&
        document.activeElement === lastElement
      ) {
        event.preventDefault();
        firstElement.focus();
      }
    }

    document.addEventListener('click', (event) => {
      const sampleButton = event.target.closest(
        '.js-open-sample-popup'
      );

      if (sampleButton) {
        event.preventDefault();
        openPopup(sampleButton);
        return;
      }

      const closeControl = event.target.closest(
        '[data-close-sample-popup]'
      );

      if (closeControl || event.target === popup) {
        event.preventDefault();
        closePopup();
      }
    });

    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup();
        return;
      }

      handleFocusTrap(event);
    });

    form.addEventListener('change', (event) => {
      if (!event.target.matches('.sample-material-radio')) {
        return;
      }

      const wallpaperTypeInput = form.querySelector(
        '[data-sample-wallpaper-type]'
      );

      if (wallpaperTypeInput) {
        wallpaperTypeInput.value =
          event.target.dataset.title || '';
      }
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      /*
       * Prevent double clicks or duplicated submit events from
       * producing more than one cart request.
       */
      if (isSubmitting) return;

      const selectedVariant = form.querySelector(
        '.sample-material-radio:checked'
      );
      const submitButton = form.querySelector(
        '.sample-add-cart-btn'
      );
      const buttonText = submitButton?.querySelector('.btn-text');
      const spinner = submitButton?.querySelector(
        '.loading__spinner'
      );

      if (!selectedVariant) {
        updateStatus(
          'Please select a sample material.',
          true
        );
        return;
      }

      isSubmitting = true;
      updateStatus('Adding your sample to the cart…');

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }

      buttonText?.classList.add('hidden');
      spinner?.classList.remove('hidden');

      const properties = {
        'Main Product Id': form.dataset.productId || '',
        'Main Product': form.dataset.productTitle || '',
        'Main Product Handle':
          form.dataset.productHandle || '',
        'Wallpaper Type':
          selectedVariant.dataset.title || '',
        'Main Product Image':
          form.dataset.productImage || ''
      };

      const rootRoute =
        window.Shopify?.routes?.root || '/';

      try {
        /*
         * This is the controller's only cart request.
         */
        const response = await fetch(
          `${rootRoute}cart/add.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: Number(selectedVariant.value),
              quantity: 1,
              properties
            })
          }
        );

        if (!response.ok) {
          let errorMessage =
            'The sample could not be added. Please try again.';

          try {
            const errorData = await response.json();

            if (errorData.description) {
              errorMessage = errorData.description;
            } else if (errorData.message) {
              errorMessage = errorData.message;
            }
          } catch (parseError) {
            // Keep the default shopper-facing message.
          }

          throw new Error(errorMessage);
        }

        updateStatus('Sample added. Opening your cart…');

        window.location.assign(`${rootRoute}cart`);
      } catch (error) {
        updateStatus(
          error.message ||
            'The sample could not be added. Please try again.',
          true
        );
      } finally {
        isSubmitting = false;

        if (submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
        }

        buttonText?.classList.remove('hidden');
        spinner?.classList.add('hidden');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeSamplePopup,
      { once: true }
    );
  } else {
    initializeSamplePopup();
  }
})();